import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import {RegisterComponent} from "./pages/register/register.component";
import {HomeComponent} from "./pages/home/home.component";
import {ResetComponent} from "./pages/reset/reset.component";
import {AhorrosComponent} from "./pages/ahorros/ahorros.component";
import {CarteraComponent} from "./pages/cartera/cartera.component";
import {ServiciosComponent} from "./pages/servicios/servicios.component";
import {CodeudoresComponent} from "./pages/codeudores/codeudores.component";
import {TarjetaComponent} from "./pages/tarjeta/tarjeta.component";
import {SeguridadComponent} from "./pages/seguridad/seguridad.component";
import {DocumentosComponent} from "./pages/documentos/documentos.component";
import {DescuentosComponent} from "./pages/descuentos/descuentos.component";
import {SimuladorComponent} from "./pages/simulador/simulador.component";
import {SolicitudesComponent} from "./pages/solicitudes/solicitudes.component";
import {ActualizacionComponent } from './pages/actualizacion/actualizacion.component';
import {PolizasComponent} from './pages/polizas/polizas.component';
import { SeguroComponent } from './pages/seguro/seguro.component';
import { PagosComponent } from './pages/pagos/pagos.component';
import { SolicitudesNewComponent } from './pages/solicitudes-new/solicitudes-new.component';
import { DecsisCloudComponent } from './pages/decsis-cloud/decsis-cloud.component';
import { ManualesComponent } from './pages/manuales/manuales.component';
import { CircularesComponent } from './pages/circulares/circulares.component';
import { ValidAfiliacionComponent } from './pages/valid-afiliacion/valid-afiliacion.component';
import { AfiliacionComponent } from './pages/afiliacion/afiliacion.component';
import { TotalesComponent } from './pages/totales/totales.component';
import { VotacionesComponent } from './pages/votaciones/votaciones.component';
import { SolicitudesServiciosComponent } from './pages/solicitudes-servicios/solicitudes-servicios.component';
import { PseFsvComponent } from './pages/pse-fsv/pse-fsv.component';
import { Page404Component } from './pages/page404/page404.component';
import { ConfirmPseComponent } from './pages/confirm-pse/confirm-pse.component';
import { InfoCodextComponent } from './pages/info-codext/info-codext.component';

const routes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'login', component: LoginComponent, pathMatch: 'full'},
  {path: 'salir/:sure', component: LoginComponent, pathMatch: 'full'},
  {path: 'home', component: HomeComponent, pathMatch: 'full'},
  {path: 'descuentos', component: DescuentosComponent, pathMatch: 'full'},
  {path: 'reset', component: ResetComponent, pathMatch: 'full'},
  {path: 'register', component: RegisterComponent, pathMatch: 'full'},
  {path: 'ahorros', component: AhorrosComponent, pathMatch: 'full'},
  {path: 'cartera', component: CarteraComponent, pathMatch: 'full'},
  {path: 'servicios', component: ServiciosComponent, pathMatch: 'full'},
  {path: 'codeudorde', component: CodeudoresComponent, pathMatch: 'full'},
  {path: 'tarjeta_afin', component: TarjetaComponent, pathMatch: 'full'},
  {path: 'tarjeta_cred', component: TarjetaComponent, pathMatch: 'full'},
  {path: 'seguridad', component: SeguridadComponent, pathMatch: 'full'},
  {path: 'documentos', component: DocumentosComponent, pathMatch: 'full'},
  {path: 'simulador', component: SimuladorComponent, pathMatch: 'full'},
  {path: 'actualizacion', component: ActualizacionComponent, pathMatch: 'full'},
  {path: 'polizas', component: PolizasComponent, pathMatch: 'full'},
  {path: 'solicitudes', component: SolicitudesComponent, pathMatch: 'full'},
  {path: 'seguro', component: SeguroComponent, pathMatch: 'full'},
  {path: 'pagos', component: PagosComponent, pathMatch: 'full'},
  {path: 'solCred', component: SolicitudesNewComponent, pathMatch: 'full'},
  {path: 'decsisCloud', component: DecsisCloudComponent, pathMatch: 'full'},
  {path: 'manuales', component: ManualesComponent, pathMatch: 'full'},
  {path: 'circulares', component: CircularesComponent, pathMatch: 'full'},
  {path: 'afiliacion', component: ValidAfiliacionComponent, pathMatch: 'full'},
  {path: 'afiliacion-form', component: AfiliacionComponent, pathMatch: 'full'},
  {path: 'totales', component: TotalesComponent, pathMatch: 'full'},
  {path: 'votaciones', component: VotacionesComponent, pathMatch: 'full'},
  {path: 'solServ', component: SolicitudesServiciosComponent, pathMatch: 'full'},
  {path: 'pseFsv', component: PseFsvComponent, pathMatch: 'full'},
  {path: 'confirmacion/:id', component: ConfirmPseComponent, pathMatch: 'full'},
  {path: 'firmarPagare/:token/:numsol/:nit', component: InfoCodextComponent, pathMatch: 'full'},
  {path: '**', component: Page404Component}
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
